<template>
  <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb" v-if="levelList">
      <el-breadcrumb-item
        :key="0"
        v-if="levelList.company.name"
        :to="superRole ? { path: `/company/info/${levelList.company.uid}`} : null"
        >Company: {{ levelList.company.name }}</el-breadcrumb-item
      >
      <el-breadcrumb-item
      :key="1"
        v-if="levelList.project.name"
        :to="{ path: `/project/${levelList.project.uid}${getRef}` }"
        >Project: {{ levelList.project.name }}</el-breadcrumb-item
      >
      <el-breadcrumb-item
      :key="2"
        v-if="levelList.customer.name"
        :to="{
          path: `/customer/view/${levelList.project.uid}/${levelList.customer.uid}`,
        }"
        >Customer: {{ levelList.customer.name }}</el-breadcrumb-item
      >
      <el-breadcrumb-item :key="3" v-if="levelList.bankaccount.name">Bank Account: {{
        levelList.bankaccount.name
      }}</el-breadcrumb-item>
      <el-breadcrumb-item :key="4" v-if="lastname">{{
        lastname
      }}</el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { getBreadcrumbs } from "@/api/breadcrumb";
export default {
  props:{
    company:String,
    project:String,
    customer:String,
    bankaccount: String,
    lastname: String
  },
  computed:{
    requestKey(){
      return [this.company, this.project, this.customer, this.bankaccount].join('|')
    },
    getRef(){
      return (this.$route.query.ref && this.$route.query.ref === 'customer') ? `?tab=customer` : '';
    },
    superRole(){
      return this.roleAuth([this.role.spadmin])
    }
  },
  watch:{
    // Props often arrive after mount (store / async parent data), so refetch on change
    // instead of keeping a breadcrumb built from empty props.
    requestKey(){
      this.getBreadcrumbsData()
    }
  },
  data() {
    return {
      levelList: null,
      requestSeq: 0,
    }
  },
  methods:{
    getBreadcrumbsData(retry = true){
      const formData = {}

      if(this.company) formData.company = this.company
      if(this.project) formData.project = this.project
      if(this.customer) formData.customer = this.customer
      if(this.bankaccount) formData.bankaccount = this.bankaccount

      // Ignore responses that come back after a newer request was sent.
      const seq = ++this.requestSeq
      getBreadcrumbs(formData).then(({result, data})=>{
        if(seq !== this.requestSeq) return
        if(result && data){
          this.levelList = data
        }else if(retry){
          this.getBreadcrumbsData(false)
        }
      }).catch(()=>{
        // Keep the last breadcrumb on screen and retry once on a failed request.
        if(seq === this.requestSeq && retry){
          setTimeout(()=> this.getBreadcrumbsData(false), 2000)
        }
      })

    },
    reload(){
      this.getBreadcrumbsData()
    }
  },
  created() {
    this.getBreadcrumbsData()
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 12px;
  margin-bottom: 10px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
